<template>
  <div>

    <el-table
        class="history-table"
        v-if="loyaltyHistory"
        :data="loyaltyHistory"
        v-loading="loading"
        style="width: 100%">
      <el-table-column

          label="Действие"
      >
        <template slot-scope="scope">
          {{ scope.row.title}}
        </template>

      </el-table-column>
      <el-table-column
          prop="date"
          label="Дата"
          align="left"
          width="140">
        <template slot-scope="scope">
          {{ $root.dateDefault(scope.row.date) }}, {{ $root.timeIso(scope.row.date) }}
        </template>
      </el-table-column>
      <el-table-column
          prop="initiated_by.name"
          label="Оператор"
          align="left"
          width="100"
      >
      </el-table-column>
      <el-table-column
          align="left"
          width="75"
          prop="amount"
          label="Бонусы">
        <template slot-scope="scope">
          <div :class="['amount-value', `amount-value__${scope.row.type}`]">{{ getValue( scope.row) }} </div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
        v-if="showPagination"
        class="pagination"
        background
        layout="prev, pager, next"
        :page-size="pagination.per_page"
        :total="pagination.total"
        :current-page="pagination.current_page"
        @current-change="loadLogic"
    />

  </div>
</template>
<script>
export default {
  name: "HistoryTable",
  data() {
    return {
      pagination: {},
      loyaltyHistory: false,
      loading: false
    }
  },
  props: {
    typeItem: {
      required: true
    },
    user: {
      required: true
    }
  },
  watch: {
    typeItem() {
      this.loadLogic();
    }

  },
  created() {
    this.loadLogic();
  },
  computed: {
    sign() {
      return this.typeItem === 'decrease' ? '-' : '+'
    },
    showPagination() {
      if (this.pagination) {
        return this.pagination.total > this.pagination.per_page;
      } else return false;
    },
  },
  methods: {
    getValue (data) {
      return data.type === "decrease" ? `-${data.amount}H₵` : `+${data.amount}H₵`
    },
    loadLogic(page = 1) {
      this.loading = true;

      let data = {
        params: {
          search: this.typeItem === "history" ? "" : this.typeItem,
          page
        }
      }

      this.$api.loyalty.history(this.user.id, data)
          .then((response) => {
            this.loyaltyHistory = response.data.data
            if (response.data.meta)
              this.pagination = response.data.meta.pagination;
          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка загрузки истории лояльности 😕",
              message: response.response.data.message,
            });

          })
          .finally(() => {

            this.loading = false
          });

    },

  }
}
</script>
<style lang="scss" scoped>
.history-table {
  padding-top:  24px;

  /deep/ tr .cell {
    font-style: normal;
    font-weight: normal;




    font-size: 14px;
    line-height: 22px;

    color: #111;

  }


  /deep/ th .cell {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;

    color: #111;
  }


  /deep/ th.is-leaf, td {
    padding: 6px 0 !important;
    border-bottom: none;
  }


  /deep/ .el-table__row {
    td {
      padding: 9px 0 !important;
      border-bottom: 0 !important;
    }


  }


}


.amount-value {
  float: right;
  width: max-content;
  min-width: 55px;
  margin: 0 auto;

  padding: 5px 0;

  background: #CCF9EF;
  border-radius: 4px;

  font-weight: 500;

  text-align: center;

  font-size: 14px;
  line-height: 22px;
  color: #676767;

  &__decrease {
    background: #FFD8D8;
  }

  &__increase {
    background: #CCF9EF;
  }

}

.pagination {
  padding: 0;
  margin: 10px  0 0 -5px;
}


</style>
